import { apiInstance } from './api';
import { ApiRoutes } from './consts';

export const getRequestById = async (id: string) => {
  return apiInstance.get(`${ApiRoutes.Requests}/${id}`);
};

export const getPaginatedRequests = async ({
  limit,
  page,
  order,
  sortBy,
  text,
}: {
  page: number;
  limit: number;
  sortBy?: 'createdAt' | 'customer' | 'photos' | 'rating';
  order?: 'ASC' | 'DESC';
  text?: string;
}) => {
  return apiInstance.get(`${ApiRoutes.Ratings}/`, {
    params: { page, limit, sortBy, order, text },
  });
};

export const deleteRequest = async (id: string) => {
  return apiInstance.delete(`${ApiRoutes.Ratings}/${id}`);
};

export const updateRequest = async (
  requestId: string,
  data: {
    openedEmail?: boolean;
    openedSms?: boolean;
  },
  accessToken?: string,
  businessId?: string
) => {
  return apiInstance.put(`${ApiRoutes.Requests}/request/${requestId}`, data, {
    headers: {
      ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
      ...(businessId ? { 'ECHO-Business-ID': businessId } : {}),
    },
  });
};

export const getCustomerOpenCounts = async (customerId: string) => {
  return apiInstance.get(`${ApiRoutes.Requests}/customer/${customerId}/open-counts`);
};
